import React from 'react';
import { Link } from 'react-router-dom';
import { LEGAL } from '../../lib/legal';

export const WANNAWARE_URL = 'https://www.wannaware.com';

/**
 * The legal footer: copyright, "Created by WannaWare" (logo → wannaware.com), About, Help, Terms, Privacy, Contact.
 * `compact` for the landing page (one tight row under the demo window).
 */
export const SiteFooter = ({ compact = false, className = '', testId = 'site-footer' }) => {
  const year = new Date().getFullYear();
  const link = 'rounded-sm underline-offset-2 hover:underline hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';
  const logoH = compact ? 34 : 42;
  return (
    <footer className={`shrink-0 w-full max-w-[1480px] mx-auto px-3 sm:px-6 ${compact ? 'min-h-10 py-1' : 'py-4'} flex items-center ${className}`} data-testid={testId}>
      <div className={`w-full flex flex-wrap items-center justify-between ${compact ? 'gap-x-4 gap-y-1 text-[11px]' : 'gap-x-5 gap-y-2 text-xs'} text-muted-foreground`}>
        <span data-testid={`${testId}-copyright`}>© {year} {LEGAL.operator} · {LEGAL.brand}</span>
        <a
          href={WANNAWARE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-sm hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          title="WannaWare — visit wannaware.com"
          data-testid={`${testId}-created-by`}
        >
          <span>Created by</span>
          <img src="/wannaware-logo.png" alt="WannaWare" height={logoH} style={{ height: logoH, width: 'auto' }} className="block select-none" draggable={false} data-testid={`${testId}-wannaware-logo`} />
        </a>
        <span className="flex items-center gap-x-4">
          <Link to="/about" className={link} data-testid={`${testId}-about`}>About</Link>
          <Link to="/help" className={link} data-testid={`${testId}-help`}>Help</Link>
          <Link to="/terms" className={link} data-testid={`${testId}-terms`}>Terms</Link>
          <Link to="/privacy" className={link} data-testid={`${testId}-privacy`}>Privacy</Link>
          <a href={`mailto:${LEGAL.contactEmail}`} className={link} data-testid={`${testId}-contact`}>Contact</a>
        </span>
      </div>
    </footer>
  );
};
